module.exports = __webpack_public_path__ + "img/Milestone.5e0eb2e8.svg";